import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const PrivacyPolicy: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Politique de confidentialité
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        La présente politique de confidentialité explique comment Bratan Family collecte, utilise
        et protège vos données personnelles dans le cadre de l’utilisation du Site et de vos
        achats en ligne.
      </Typography>

      <Box mt={4}>
        <Typography variant="h6" gutterBottom>
          1. Responsable du traitement
        </Typography>
        <Typography variant="body1" paragraph>
          Le responsable du traitement des données personnelles est <strong>Bratan Family</strong>,
          [forme juridique ou statut]. Pour toute question relative à la protection de vos données,
          vous pouvez contacter Bratan Family à l’adresse e-mail suivante :
          bratanfamily59@gmail.com.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          2. Données collectées
        </Typography>
        <Typography variant="body1" paragraph>
          Dans le cadre de la gestion du Site et de vos commandes, Bratan Family peut collecter les
          catégories de données suivantes :
        </Typography>
        <Typography variant="body1" paragraph>
          • <strong>Données d’identification</strong> : nom, prénom, adresse e-mail, mot de passe
          (stocké de manière chiffrée), numéro de téléphone.
          <br />
          • <strong>Données de livraison et de facturation</strong> : adresses postales, pays,
          informations nécessaires à l’acheminement des commandes.
          <br />
          • <strong>Données relatives aux commandes</strong> : produits commandés, montants,
          réductions, statut de commande, historique d’achats.
          <br />
          • <strong>Données relatives à la navigation et aux préférences</strong> : contenu du
          panier, liste de favoris, paramètres de compte, informations issues des cookies et du
          stockage local (par exemple localStorage).
          <br />
          • <strong>Données de paiement</strong> : les paiements sont traités par un prestataire de
          paiement spécialisé (tel que Stripe). Le Site ne stocke pas les numéros complets de carte
          bancaire ni les cryptogrammes ; seules des informations partielles ou techniques
          nécessaires au suivi des transactions peuvent être conservées (par exemple les quatre
          derniers chiffres de la carte ou un identifiant de transaction Stripe).
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          3. Finalités et bases légales du traitement
        </Typography>
        <Typography variant="body1" paragraph>
          Vos données sont traitées pour les finalités suivantes :
        </Typography>
        <Typography variant="body1" paragraph>
          • Gestion de votre compte client et authentification.
          <br />
          • Traitement des commandes, paiement en ligne et suivi des livraisons.
          <br />
          • Gestion de votre panier, de vos favoris et de votre historique de commandes.
          <br />
          • Envoi de communications liées à vos commandes ou à votre compte.
          <br />
          • Envoi éventuel d’offres promotionnelles et d’actualités de Bratan Family (si vous y avez
          consenti).
          <br />
          • Amélioration du Site, mesure d’audience, prévention de la fraude et sécurité.
        </Typography>
        <Typography variant="body1" paragraph>
          Ces traitements reposent, selon les cas, sur l’exécution du contrat (gestion des
          commandes et du compte), le respect d’obligations légales (facturation, comptabilité),
          votre consentement (prospection commerciale, certains cookies) ou l’intérêt légitime de
          Bratan Family (amélioration du service, lutte contre la fraude).
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          4. Destinataires des données
        </Typography>
        <Typography variant="body1" paragraph>
          Vos données sont principalement destinées à Bratan Family et aux personnes habilitées à
          gérer la boutique en ligne (service client, administration du Site).
        </Typography>
        <Typography variant="body1" paragraph>
          Elles peuvent également être transmises à des prestataires techniques et partenaires de
          confiance, dans la mesure nécessaire à l’exécution de leurs missions : prestataire
          d’hébergement, prestataire de paiement (par exemple Stripe), prestataire d’envoi d’e-mails
          transactionnels, transporteurs et services de livraison.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          5. Durée de conservation
        </Typography>
        <Typography variant="body1" paragraph>
          Vos données sont conservées pendant la durée nécessaire à la gestion de la relation
          commerciale (compte client, commandes, livraisons) et conformément aux obligations
          légales applicables, notamment en matière comptable et fiscale.
        </Typography>
        <Typography variant="body1" paragraph>
          Les données relatives à la prospection commerciale sont conservées pendant une durée
          maximale de trois ans à compter du dernier contact actif de votre part, sauf retrait
          préalable de votre consentement.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          6. Vos droits
        </Typography>
        <Typography variant="body1" paragraph>
          Conformément à la réglementation applicable en matière de protection des données
          personnelles, vous disposez d’un droit d’accès, de rectification, d’effacement, de
          limitation du traitement, d’opposition et de portabilité de vos données, dans les limites
          prévues par la loi.
        </Typography>
        <Typography variant="body1" paragraph>
          Vous pouvez également définir des directives relatives au sort de vos données après votre
          décès, et retirer votre consentement à tout moment pour les traitements fondés sur celui-
          ci (notamment la réception d’offres promotionnelles).
        </Typography>
        <Typography variant="body1" paragraph>
          Pour exercer vos droits, il vous suffit de contacter Bratan Family via le formulaire de
          contact du Site ou l’adresse e-mail mentionnée ci-dessus, en précisant votre identité et
          l’objet de votre demande.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          7. Cookies et stockage local
        </Typography>
        <Typography variant="body1" paragraph>
          Le Site utilise des cookies et des mécanismes de stockage local (par exemple
          localStorage) afin d’assurer le bon fonctionnement du panier, de la liste de favoris, de
          la session de connexion, de la bannière de gestion des cookies, ainsi que pour mesurer
          l’audience et améliorer l’expérience utilisateur.
        </Typography>
        <Typography variant="body1" paragraph>
          Vous pouvez configurer votre navigateur pour refuser tout ou partie des cookies ou être
          averti de leur dépôt. Cependant, le refus de certains cookies strictement nécessaires
          peut dégrader votre expérience sur le Site et empêcher l’accès à certaines
          fonctionnalités (compte client, panier, historique de commandes, etc.).
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          8. Sécurité
        </Typography>
        <Typography variant="body1" paragraph>
          Bratan Family met en œuvre les mesures techniques et organisationnelles appropriées afin
          de protéger vos données personnelles contre les accès non autorisés, la perte, la
          altération ou la divulgation. Toutefois, aucun système n’est totalement sécurisé et
          Bratan Family ne peut garantir une sécurité absolue des informations transmises en ligne.
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          9. Réclamations
        </Typography>
        <Typography variant="body1" paragraph>
          Si vous estimez, après avoir contacté Bratan Family, que vos droits ne sont pas
          respectés, vous avez la possibilité d’introduire une réclamation auprès de l’autorité de
          contrôle compétente en matière de protection des données personnelles.
        </Typography>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
